export function formatFileSize(sizeInBytes) {
  if ((typeof sizeInBytes !== 'number' && !Number(sizeInBytes)) || sizeInBytes <= 0) {
    return 0;
  }
  if (sizeInBytes < 1024 * 1024) {
    return `${Math.round(sizeInBytes / 1024)}KB`;
  }
  return `${Math.round((sizeInBytes / (1024 * 1024)) * 10) / 10}MB`;
}
